export default "__VITE_ASSET__37fee432__"